/* Practiko - boton flotante de WhatsApp */
(function(){
  if (document.getElementById('pk-wa')) return;
  var num = '50689027528';
  var msg = 'Hola Practiko, tengo una consulta';
  if (location.pathname.indexOf('/products/') === 0) {
    var h = document.querySelector('h1');
    if (h) msg = 'Hola Practiko, me interesa: ' + h.textContent.trim();
  }
  var a = document.createElement('a');
  a.id = 'pk-wa';
  a.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(msg);
  a.target = '_blank';
  a.rel = 'noopener';
  a.setAttribute('aria-label', 'Escribinos por WhatsApp');
  a.innerHTML = '<svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true"><path fill="#fff" d="M16.02 3C8.84 3 3 8.83 3 16c0 2.3.6 4.53 1.75 6.5L3 29l6.68-1.72A12.95 12.95 0 0 0 16.02 29C23.2 29 29 23.17 29 16S23.2 3 16.02 3zm0 23.6c-2 0-3.950-.54-5.65-1.56l-.4-.24-3.96 1.02 1.06-3.86-.26-.4A10.56 10.56 0 0 1 5.4 16c0-5.850 4.770-10.6 10.620-10.6 5.840 0 10.580 4.750 10.580 10.6 0 5.850-4.740 10.6-10.580 10.6zm5.8-7.930c-.32-.16-1.880-.93-2.170-1.030-.29-.11-.5-.16-.71.16-.21.32-.82 1.030-1 1.240-.19.21-.37.24-.69.08-.32-.16-1.340-.5-2.550-1.580-.94-.84-1.580-1.880-1.760-2.200-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.71-1.720-.98-2.350-.26-.62-.52-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.110 1.090-1.110 2.650s1.140 3.070 1.300 3.280c.16.21 2.240 3.420 5.430 4.800.76.33 1.350.52 1.810.67.76.24 1.450.2 2 .12.61-.09 1.880-.77 2.140-1.510.27-.74.27-1.380.19-1.510-.08-.13-.29-.21-.61-.37z"/></svg>';
  var s = a.style;
  s.position = 'fixed'; s.right = '16px'; s.bottom = '20px'; s.zIndex = '60';
  s.width = '56px'; s.height = '56px'; s.borderRadius = '50%';
  s.background = '#25D366'; s.display = 'flex'; s.alignItems = 'center'; s.justifyContent = 'center';
  s.boxShadow = '0 8px 20px -6px rgba(15,23,42,.45)';
  document.body.appendChild(a);
})();
